import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import {
  Spin,
  Select,
  DatePicker,
  Button,
  Input,
  Empty,
  message,
  Table,
} from "antd";
import { useParams } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { useNavigate } from "react-router-dom";
// import Table from "../../../../core/pagination/datatable";
import {
  CheckOutlined,
  CloseOutlined,
  FilterOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
// import { BASE_CRM_URL } from "../../../components/config/config";
import { API_BASE_CRM_URL } from "../../Config/Config";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
// import Pagination from "../../Config/Pagination";
// import { RELATED_TO_OPTIONS } from "../Tasks/taskApi";
// const BASE_CRM_URL = "http://192.168.1.21:3008/accumen/";

const Reports = () => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");

  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  const userId = userDetails?.userId || userDetails?.staffid;

  const { reportId } = useParams();
  const actualReportId = Number(reportId?.split("=")[1]);
  const isNotesOrReminders = [3, 4].includes(Number(actualReportId));
  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const [reportConfig, setReportConfig] = useState(null);
  const [filterValues, setFilterValues] = useState({});
  console.log(filterValues, "ssssssssssssss");
  console.log(reportConfig, "reportConfig");
  const [customers, setCustomers] = useState([]);
  const [leads, setLeads] = useState([]);

  const [relatedOptions, setRelatedOptions] = useState([]);

  const [staff, setStaff] = useState([]);

  console.log(relatedOptions, "relatedOptions");

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [configLoading, setConfigLoading] = useState(false);

  const [searchText, setSearchText] = useState("");

  const [showFilters, setShowFilters] = useState(true);

  // const itemsPerPage = 10;

  // const filteredItems = useMemo(() => {
  //   const results = productsData.filter((item) =>
  //     item.number.toString().includes(searchTerm.toLowerCase()),
  //   );

  //   setCurrentPage(1);

  //   return results;
  // }, [productsData, searchTerm]);

  // Calculate indices for slicing data
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // DEFAULT FILTER VALUES

  const RELATED_TO_OPTIONS = [
    { value: "lead", label: "Lead" },
    { value: "customer", label: "Customer" },
    { value: "project", label: "Project" },
    { value: "invoice", label: "Invoice" },
    { value: "estimate", label: "Estimate" },
    { value: "proposal", label: "Proposal" },
    { value: "creditNote", label: "CreditNote" },
  ];

  const getDefaultFilterValues = (filters = []) => {
    const defaultValues = {};

    filters.forEach((filter) => {
      if (isNotesOrReminders) {
        if (filter.key === "fromDate") {
          defaultValues[filter.key] = dayjs();
        } else if (filter.key === "toDate") {
          defaultValues[filter.key] = dayjs();
        } else {
          defaultValues[filter.key] = null;
        }
      } else {
        if (filter.key === "fromDate") {
          defaultValues[filter.key] = dayjs().startOf("year");
        } else if (filter.key === "toDate") {
          defaultValues[filter.key] = dayjs();
        } else {
          defaultValues[filter.key] = null;
        }
      }
    });

    // Default dropdown
    if (isNotesOrReminders) {
      defaultValues.dateRange = "today";
    }

    return defaultValues;
  };

  // GET REPORT CONFIG

  const getReportConfig = async () => {
    try {
      setConfigLoading(true);

      const response = await axios.get(
        `${API_BASE_CRM_URL}reports/GetReportConfig`,
        {
          params: {
            reportId: actualReportId,
          },
        },
      );

      if (response.data?.Status) {
        const result = response.data.ResultData;

        setReportConfig(result);

        const defaultValues = getDefaultFilterValues(result?.filters || []);

        setFilterValues(defaultValues);
      } else {
        setReportConfig(null);
        message.error(
          response.data?.Message || "Failed to load report configuration",
        );
      }
    } catch (error) {
      console.error("Report Config API Error:", error);
      setReportConfig(null);
      message.error("Failed to load report configuration");
    } finally {
      setConfigLoading(false);
    }
  };

  // GET CUSTOMERS

  const getCustomers = async () => {
    console.log("getcustom");
    try {
      const response = await axios.get(
        `${API_BASE_CRM_URL}customers/GetCustomers`,
      );

      if (response.data?.Status) {
        const data = response.data.ResultData || [];

        setCustomers(
          data
            .map((item) => ({
              value: item.id ?? item.customerid ?? item.customerId,
              label:
                item.company ??
                item.customername ??
                item.customerName ??
                item.name ??
                `Customer ${item.id}`,
            }))
            .filter((item) => item.value != null),
        );
      }
    } catch (error) {
      console.error("Customer API Error:", error);
    }
  };

  console.log(customers, "customerssssss");
  console.log(leads, "leads");
  // GET LEADS

  const getLeads = async () => {
    try {
      const response = await axios.get(`${API_BASE_CRM_URL}leads/GetLeads`);

      if (response.data?.Status) {
        const data = response.data.ResultData || [];

        setLeads(
          data
            .map((item) => ({
              value: item.id ?? item.leadid ?? item.leadId,
              label:
                item.name ??
                item.leadname ??
                item.leadName ??
                item.company ??
                `Lead ${item.id}`,
            }))
            .filter((item) => item.value != null),
        );
      }
    } catch (error) {
      console.error("Lead API Error:", error);
    }
  };

  const getStaff = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}staff/GetStaffDropdown`);
      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        setStaff(
          data.ResultData.map((item) => ({
            value: item.staffid,
            label: `${item.firstname} ${item.lastname || ""}`.trim(),
          })).filter((item) => item.value != null),
        );
      } else {
        setStaff([]);
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      setStaff([]);
    }
  };

  const getRelatedRecords = async (type) => {
    try {
      setLoading(true);

      let url = "";

      switch (type) {
        case "lead":
          url = `${API_BASE_CRM_URL}leads/GetLeads`;
          break;

        case "customer":
          url = `${API_BASE_CRM_URL}customers/GetCustomers`;
          break;

        case "project":
          url = `${API_BASE_CRM_URL}project/GetProjects`;
          break;

        case "invoice":
          url = `${API_BASE_CRM_URL}invoice/GetInvoices`;
          break;

        case "estimate":
          url = `${API_BASE_CRM_URL}estimates/GetEstimates`;
          break;

        case "proposal":
          url = `${API_BASE_CRM_URL}proposal/GetProposals`;
          break;

        case "creditNote":
          url = `${API_BASE_CRM_URL}creditnotes/GetCreditNotes`;
          break;

        default:
          return;
      }

      const response = await axios.get(url);

      if (response.data?.Status) {
        const data = response.data.ResultData || response.data.Data || [];

        let options = [];

        switch (type) {
          case "lead":
            options = data.map((item) => ({
              value: item.id ?? item.leadid ?? item.leadId,
              label:
                item.name ??
                item.leadname ??
                item.leadName ??
                item.company ??
                `Lead ${item.id}`,
            }));
            break;

          case "customer":
            options = data.map((item) => ({
              value: item.id ?? item.customerid ?? item.customerId,
              label:
                item.company ??
                item.customername ??
                item.customerName ??
                item.name ??
                `Customer ${item.id}`,
            }));
            break;

          case "project":
            options = data.map((item) => ({
              value: item.id,
              label: item.name,
            }));
            break;

          case "invoice":
            options = data.map((item) => ({
              value: item.id,
              label: item.InvoiceNo,
            }));
            break;

          case "estimate":
            options = data.map((item) => ({
              value: item.id,
              label: item.Estimatenumber,
            }));
            break;

          case "proposal":
            options = data.map((item) => ({
              value: item.id,
              label: item.number,
            }));
            break;

          case "creditNote":
            options = data.map((item) => ({
              value: item.id,
              label: item.credit_note_number,
            }));
            break;

          default:
            options = [];
        }

        setRelatedOptions(options.filter((item) => item.value != null));
      } else {
        setRelatedOptions([]);
      }
    } catch (error) {
      console.error("Related Record API Error:", error);
      setRelatedOptions([]);
    } finally {
      setLoading(false);
    }
  };

  // INITIAL LOAD

  useEffect(() => {
    setReportConfig(null);
    setReportData([]);
    setSearchText("");
    setFilterValues({});

    getReportConfig();
  }, [actualReportId]);

  // LOAD DROPDOWN DATA BASED ON CONFIG

  useEffect(() => {
    if (!reportConfig?.filters) return;

    const hasCustomerFilter = reportConfig.filters.some(
      (filter) =>
        filter.key === "customerId" ||
        filter.key === "customerid" ||
        filter.key === "CustomerId",
    );

    const hasLeadFilter = reportConfig.filters.some(
      (filter) => filter.key === "leadId",
    );

    const hasStaffFilter = reportConfig.filters.some(
      (filter) => filter.key === "staffid",
    );

    console.log(hasCustomerFilter, "hascustomerfilter");
    if (hasCustomerFilter) {
      getCustomers();
    } else {
      setCustomers([]);
    }

    if (hasLeadFilter) {
      getLeads();
    } else {
      setLeads([]);
    }

    if (hasStaffFilter) {
      getStaff();
    } else {
      setStaff([]);
    }
  }, [reportConfig]);

  // HANDLE FILTER CHANGE

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // GET REPORT DATA

  const getReportData = async (values = filterValues) => {
    try {
      if (!reportConfig) return;

      setLoading(true);

      const params = {
        reportId: actualReportId,
      };

      // ==========================================
      // NOTES / REMINDERS
      // ==========================================
      if (isNotesOrReminders) {
        const selectedRange = values.dateRange;

        // FROM DATE IS ALWAYS TODAY
        const today = dayjs();

        let fromDate = today.format("YYYY-MM-DD");
        let toDate = today.format("YYYY-MM-DD");

        if (selectedRange === "today") {
          fromDate = today.startOf("day").format("YYYY-MM-DD");
          toDate = today.endOf("day").format("YYYY-MM-DD");
        }

        if (selectedRange === "week") {
          fromDate = today.subtract(6, "day").format("YYYY-MM-DD");
          toDate = today.format("YYYY-MM-DD");
        }

        if (selectedRange === "month") {
          fromDate = today.startOf("month").format("YYYY-MM-DD");
          toDate = today.endOf("month").format("YYYY-MM-DD");
        }

        params.fromDate = fromDate;
        params.toDate = toDate;

        // User ID from session
        if (userId) {
          params.staffid = userId;
        }

        console.log("Notes/Reminders API Params:", params);
      }

      // ==========================================
      // OTHER REPORTS
      // ==========================================
      reportConfig.filters?.forEach((filter) => {
        // IMPORTANT:
        // Do not add old fromDate/toDate/staffid
        // for Notes/Reminders
        if (
          isNotesOrReminders &&
          (filter.key === "fromDate" ||
            filter.key === "toDate" ||
            filter.key === "staffid")
        ) {
          return;
        }

        const value = values[filter.key];

        if (value !== undefined && value !== null && value !== "") {
          if (filter.type === "date" && dayjs.isDayjs(value)) {
            params[filter.key] = value.format("YYYY-MM-DD");
          } else {
            params[filter.key] = value;
          }
        }
      });

      console.log("FINAL Report API Params:", params);

      // ==========================================
      // GET REPORT
      // ==========================================
      const response = await axios.get(
        `${API_BASE_CRM_URL}reports/GetReports`,
        {
          params,
        },
      );

      if (response.data?.Status) {
        setReportData(response.data.ResultData || []);
      } else {
        setReportData([]);
        message.info(response.data?.Message || "No report data found");
      }
    } catch (error) {
      console.error("Report API Error:", error);
      message.error("Failed to load report data");
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  // APPLY

  const handleApply = () => {
    console.log("jhghhghjgj");
    getReportData(filterValues);
  };

  // RESET

  const handleReset = () => {
    const resetValues = getDefaultFilterValues(reportConfig?.filters || []);

    setFilterValues(resetValues);
    setSearchText("");

    getReportData(resetValues);
  };

  // FORMAT TABLE VALUE

  const formatValue = (value, key) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }

    // Date fields
    if (key?.toLowerCase().includes("date")) {
      const date = dayjs(value);

      if (date.isValid()) {
        return date.format("DD-MM-YYYY");
      }
    }

    return value;
  };

  // DYNAMIC TABLE COLUMNS

  //   const columns =
  //     reportConfig?.headers?.map((header) => ({
  //       title: header.label,
  //       dataIndex: header.key,
  //       key: header.key,
  //       render: (value) => formatValue(value, header.key),
  //     })) || [];

  // const reportId = reportConfig?.reportId || reportConfig?.ReportId;

  // ==========================================
  // DYNAMIC TABLE COLUMNS
  // ==========================================

  const currentReportId = Number(reportConfig?.reportId);

  // const columns =
  //   reportConfig?.headers
  //     ?.filter((header) => {
  //       // Remove S.No and City from all reports
  //       if (["serialnumber", "city", "staffname"].includes(header.key)) {
  //         return false;
  //       }

  //       // Remove dates from Customer Conversion Report
  //       if (
  //         currentReportId === 1 &&
  //         ["dateadded", "dateconverted"].includes(header.key)
  //       ) {
  //         return false;
  //       }

  //       return true;
  //     })
  //     .map((header) => ({
  //       title: header.label,
  //       dataIndex: header.key,
  //       key: header.key,
  //       render: (value) => (
  //         <div className="text-nowrap">{formatValue(value, header.key)}</div>
  //       ),
  //     })) || [];

  // if (currentReportId === 1) {
  //   const dateColumn = {
  //     title: "Dates",
  //     key: "dates",

  //     render: (_, record) => {
  //       const dateAdded = record.dateadded
  //         ? dayjs(record.dateadded).format("DD-MM-YYYY")
  //         : "-";

  //       const dateConverted = record.dateconverted
  //         ? dayjs(record.dateconverted).format("DD-MM-YYYY")
  //         : "-";

  //       return (
  //         <div className="text-nowrap">
  //           <div>
  //             <strong>Lead:</strong> {dateAdded}
  //           </div>

  //           <div>
  //             <strong>Converted:</strong> {dateConverted}
  //           </div>
  //         </div>
  //       );
  //     },
  //   };

  //   const customerIndex = columns.findIndex(
  //     (column) => column.key === "customername",
  //   );

  //   if (customerIndex !== -1) {
  //     columns.splice(customerIndex + 1, 0, dateColumn);
  //   } else {
  //     columns.push(dateColumn);
  //   }
  // }

  const reportColumns = {
    2: ["leadname", "Lead Date", "company"],

    // Reminders
    3: ["reminderdate", "description", "relatedto"],

    // Notes
    4: ["dateadded", "description", "relatedto"],

    // Proposal
    7: [
      "proposalid",
      "subject",
      "proposaldate",
      "proposal_to",
      "phone",
      "opentill",
      "total",
      "rel_type",
    ],
  };

  // const columns =
  //   reportConfig?.headers
  //     ?.filter((header) => {
  //       if (currentReportId === 1) {
  //         if (
  //           ["serialnumber", "staffname", "phonenumber", "city"].includes(
  //             header.key,
  //           )
  //         ) {
  //           return false;
  //         }

  //         if (["dateadded", "dateconverted"].includes(header.key)) {
  //           return false;
  //         }

  //         return true;
  //       }

  //       if (currentReportId === 2) {
  //         return reportColumns[2].includes(header.key);
  //       }

  //       if (currentReportId === 3) {
  //         return reportColumns[3].includes(header.key);
  //       }

  //       if (currentReportId === 4) {
  //         return reportColumns[4].includes(header.key);
  //       }

  //       if (currentReportId === 7) {
  //         return reportColumns[7].includes(header.key);
  //       }

  //       if (["serialnumber", "staffname", "phonenumber"].includes(header.key)) {
  //         return false;
  //       }

  //       if (header.key === "city") {
  //         return false;
  //       }

  //       return true;
  //     })

  //     ?.sort((a, b) => {
  //       if (
  //         [2, 3, 4, 7].includes(currentReportId) &&
  //         reportColumns[currentReportId]
  //       ) {
  //         return (
  //           reportColumns[currentReportId].indexOf(a.key) -
  //           reportColumns[currentReportId].indexOf(b.key)
  //         );
  //       }

  //       return 0;
  //     })
  //     ?.map((header) => ({
  //       title: header.label,
  //       dataIndex: header.key,
  //       key: header.key,

  //       render: (value, record) => {

  //         if (currentReportId === 1 && header.key === "customername") {
  //           return (
  //             <div>
  //               <div className="fw-semibold text-dark">
  //                 {record.customername || "-"}
  //               </div>

  //               <div className="text-muted small">
  //                 {record.phonenumber || "-"}{" "}
  //                 {record.city ? `, ${record.city}` : ""}
  //               </div>
  //             </div>
  //           );
  //         }
  //         if (currentReportId === 2 && header.key === "company") {
  //           return (
  //             <div>
  //               <div className="fw-semibold text-dark">
  //                 {record.company || "-"}
  //               </div>

  //               <div className="text-muted small">
  //                 {record.phonenumber || "-"}{" "}
  //                 {record.city ? `, ${record.city}` : ""}
  //               </div>
  //             </div>
  //           );
  //         }
  //         if (currentReportId === 2 && header.key === "leadname") {
  //           return (
  //             <div>
  //               <div className="fw-semibold text-dark">
  //                 {record.leadname || "-"}
  //               </div>

  //               <div className="text-muted small">
  //                 {record.dateadded || "-"}{" "}
  //               </div>
  //             </div>
  //           );
  //         }

  //         if (currentReportId === 3 && header.key === "reminderdate") {
  //           return (
  //             <div>
  //               <div className="fw-semibold text-dark">
  //                 {record.reminderdate || "-"}
  //               </div>

  //               <div className="text-muted small">
  //                 {record.relatedtype || "-"}{" "}
  //               </div>
  //             </div>
  //           );
  //         }

  //         if (currentReportId === 4 && header.key === "dateadded") {
  //           return (
  //             <div>
  //               <div className="fw-semibold text-dark">
  //                 {record.dateadded || "-"}
  //               </div>

  //               <div className="text-muted small">
  //                 {record.rel_type || "-"}{" "}
  //               </div>
  //             </div>
  //           );
  //         }

  //         if (currentReportId === 4 || currentReportId === 3) {
  //           return (
  //             <div
  //               style={{
  //                 whiteSpace: "normal",
  //                 wordBreak: "break-word",
  //                 overflowWrap: "anywhere",
  //                 maxWidth: "250px",
  //               }}
  //             >
  //               {formatValue(value, header.key)}
  //             </div>
  //           );
  //         }
  //         return (
  //           <div className="text-nowrap">{formatValue(value, header.key)}</div>
  //         );
  //       },
  //     })) || [];

  let columns =
    reportConfig?.headers
      ?.filter((header) => {
        if (currentReportId === 1) {
          if (
            ["serialnumber", "staffname", "phonenumber", "city"].includes(
              header.key,
            )
          ) {
            return false;
          }

          if (["dateadded", "dateconverted"].includes(header.key)) {
            return false;
          }

          return true;
        }

        if (currentReportId === 2) {
          return reportColumns[2].includes(header.key);
        }

        if (currentReportId === 3) {
          return reportColumns[3].includes(header.key);
        }

        if (currentReportId === 4) {
          return reportColumns[4].includes(header.key);
        }

        // IMPORTANT:
        // Don't create individual columns for Proposal here
        if (currentReportId === 7) {
          return false;
        }

        if (["serialnumber", "staffname", "phonenumber"].includes(header.key)) {
          return false;
        }

        if (header.key === "city") {
          return false;
        }

        return true;
      })
      ?.sort((a, b) => {
        if (
          [2, 3, 4].includes(currentReportId) &&
          reportColumns[currentReportId]
        ) {
          return (
            reportColumns[currentReportId].indexOf(a.key) -
            reportColumns[currentReportId].indexOf(b.key)
          );
        }

        return 0;
      })
      ?.map((header) => ({
        title: header.label,
        dataIndex: header.key,
        key: header.key,

        render: (value, record) => {
          if (currentReportId === 1 && header.key === "customername") {
            return (
              <div>
                <div className="fw-semibold text-dark">
                  {record.customername || "-"}
                </div>

                <div className="text-muted small">
                  {record.phonenumber || "-"}
                  {record.city ? `, ${record.city}` : ""}
                </div>
              </div>
            );
          }

          if (Number(currentReportId) === 2 && header.key === "company") {
            return (
              <div>
                <div className="fw-semibold text-dark">
                  {record.company
                    ? record.company.length > 20
                      ? `${record.company.slice(0, 20)}...`
                      : record.company
                    : "-"}
                </div>

                <div className="text-muted small">
                  {record.phonenumber || "-"}
                  {record.city ? `, ${record.city}` : ""}
                </div>
              </div>
            );
          }

          if (Number(currentReportId) === 2 && header.key === "leadname") {
            return (
              <div>
                <div className="fw-semibold text-dark">
                  {/* {record.leadname || "-"} */}
                  {record.leadname
                    ? record.leadname.length > 20
                      ? `${record.leadname.slice(0, 20)}...`
                      : record.leadname
                    : "-"}
                </div>

                <div className="text-muted small">
                  {record.dateadded || "-"}
                </div>
              </div>
            );
          }

          if (currentReportId === 3 && header.key === "reminderdate") {
            return (
              <div>
                <div className="fw-semibold text-dark">
                  {record.reminderdate
                    ? dayjs(record.reminderdate).format("DD-MM-YYYY HH:MM")
                    : "-"}{" "}
                </div>

                <div className="text-muted small">
                  {record.clientname
                    ? record.clientname.length > 13
                      ? `${record.clientname.slice(0, 13)}...`
                      : record.clientname
                    : "-"}{" "}
                  {"/"}
                  <span className="text-primary">
                    {record.relatedtype || "-"}
                  </span>
                </div>
              </div>
            );
          }

          if (currentReportId === 4 && header.key === "dateadded") {
            return (
              <div>
                <div className="fw-semibold text-dark">
                  {record.dateadded
                    ? dayjs(record.dateadded).format("DD-MM-YYYY")
                    : "-"}{" "}
                  <small className="text-primary">
                    {record.rel_type || "-"}
                  </small>
                </div>

                <div className="text-muted small">
                  {record.clientname
                    ? record.clientname.length > 17
                      ? `${record.clientname.slice(0, 17)}...`
                      : record.clientname
                    : "-"}
                </div>
              </div>
            );
          }

          if (currentReportId === 4 && header.key === "description") {
            const description = record.description || "";

            const mapMatch = description.match(
              /(https?:\/\/(?:www\.google\.com\/maps\?q=[^,\s\)]+(?:,[^,\s\)]+)*|maps\.app\.goo\.gl\/[^\s,\)]+))/i,
            );

            const mapUrl = mapMatch ? mapMatch[1] : null;

            const text = mapUrl
              ? description
                  .replace(mapUrl, "")
                  .replace(/^\[|\]\([^)]*\)/g, "")
                  .replace(/^,/, "")
                  .trim()
              : description;

            return (
              <div
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                  maxWidth: "210px",
                }}
              >
                {mapUrl && (
                  <a
                    href={mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm  me-2"
                  >
                    <i className="fas fa-map-marker-alt me-1"></i>
                  </a>
                )}

                {text && (
                  <span
                  // className="text-muted"
                  >
                    {text}
                  </span>
                )}
              </div>
            );
          }

          if (currentReportId === 4 || currentReportId === 3) {
            return (
              <div
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                  maxWidth: "210px",
                }}
              >
                {formatValue(value, header.key)}
              </div>
            );
          }

          return (
            <div className="text-nowrap">{formatValue(value, header.key)}</div>
          );
        },
      })) || [];

  if (currentReportId === 1) {
    const dateColumn = {
      title: "Dates",
      key: "dates",

      render: (_, record) => {
        const dateAdded = record.dateadded
          ? dayjs(record.dateadded).format("DD-MM-YYYY")
          : "-";

        const dateConverted = record.dateconverted
          ? dayjs(record.dateconverted).format("DD-MM-YYYY")
          : "-";

        return (
          <div className="text-nowrap">
            <div>
              <small>Lead:</small> {dateAdded}
            </div>

            <div>
              <small>Conv:</small> {dateConverted}
            </div>
          </div>
        );
      },
    };

    const customerIndex = columns.findIndex(
      (column) => column.key === "customername",
    );

    if (customerIndex !== -1) {
      columns.splice(customerIndex + 1, 0, dateColumn);
    } else {
      columns.push(dateColumn);
    }
  }

  if (currentReportId === 7) {
    columns = [
      {
        title: "Proposal",
        key: "proposal",
        render: (_, record) => (
          <div>
            <div className="fw-semibold text-dark">
              {record.proposalid || "-"}
            </div>

            {/* <div className="">{record.subject || "-"}</div> */}

            <div className="">{record.proposal_to || "-"}</div>
          </div>
        ),
      },

      {
        title: "Open Till",
        key: "dates_amount",
        render: (_, record) => (
          <div className="text-nowrap">
            {/* <div>
              <small>Created:</small>{" "}
              {record.proposaldate
                ? dayjs(record.proposaldate).format("DD-MM-YYYY")
                : "-"}
            </div> */}

            <div>
              {/* <small>Open</small>{" "} */}
              {record.opentill
                ? dayjs(record.opentill).format("DD-MM-YYYY")
                : "-"}
            </div>

            {/* <div>
              <small>Total:</small> {record.total || "-"}
            </div> */}
          </div>
        ),
      },

      {
        title: "Amount",
        key: "amount",
        render: (_, record) => (
          <div>
            <div>{record.total || "-"}</div>
            <div className="small text-primary">{record.rel_type || "-"}</div>

            {/* <div className="small">{record.phone || "-"}</div> */}
          </div>
        ),
      },
    ];
  }

  if (currentReportId === 5) {
    columns = [
      {
        title: "Invoice",
        key: "invoicenumber",
        render: (_, record) => (
          <div>
            <div className="fw-semibold text-dark">
              {record.invoicenumber || "-"}
            </div>

            <div className="">{record.customername || "-"}</div>
          </div>
        ),
      },

      {
        title: "DueDate",
        key: "dates_amount",
        render: (_, record) => (
          <div className="text-nowrap">
            {/* <div>
              <small>Cre:</small>{" "}
              {record.invoicedate
                ? dayjs(record.invoicedate).format("DD-MM-YYYY")
                : "-"}
            </div> */}

            <div>
              {record.duedate
                ? dayjs(record.duedate).format("DD-MM-YYYY")
                : "-"}
            </div>
          </div>
        ),
      },

      {
        title: "Amount",
        key: "amount",
        render: (_, record) => (
          <div>
            <div className="small">{record.invoicetotal || "-"}</div>
          </div>
        ),
      },
    ];
  }

  if (currentReportId === 6) {
    columns = [
      {
        title: "Estimate",
        key: "estimatenumber",
        render: (_, record) => (
          <div>
            <div className="fw-semibold text-dark">
              {record.estimatenumber || "-"}
            </div>

            <div className="">{record.customername || "-"}</div>

            {/* <div className="">{record.phonenumber || "-"}</div> */}
          </div>
        ),
      },

      {
        title: "ExpiryDate",
        key: "dates_amount",
        render: (_, record) => (
          <div className="text-nowrap">
            {/* <div>
              <small>Cre:</small>{" "}
              {record.invoicedate
                ? dayjs(record.invoicedate).format("DD-MM-YYYY")
                : "-"}
            </div> */}

            <div>
              {/* <small>Due</small>{" "} */}
              {record.expirydate
                ? dayjs(record.expirydate).format("DD-MM-YYYY")
                : "-"}
            </div>

            {/* <div>{record.city || "-"}</div> */}
          </div>
        ),
      },

      {
        title: "Amount",
        key: "amount",
        render: (_, record) => (
          <div>
            <div className="small">{record.estimatetotal || "-"}</div>
            {/* <div className="small">{record.paidamount || "-"}</div> */}

            {/* <div className="small">{record.balancedue || "-"}</div> */}
          </div>
        ),
      },
    ];
  }

  const filteredData = reportData.filter((record) => {
    if (!searchText) {
      return true;
    }

    return Object.values(record).some((value) =>
      String(value ?? "")
        .toLowerCase()
        .includes(searchText.toLowerCase()),
    );
  });

  // CONFIG LOADING

  if (configLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spin size="large" />
      </div>
    );
  }

  // CONFIG NOT FOUND

  if (!reportConfig) {
    return (
      <div className="py-5">
        <Empty description="Report configuration not found" />
      </div>
    );
  }

  // UI

  // ===============================
  // EXPORT REPORT TO PDF
  // ===============================
  const handleExportPDF = () => {
    if (!reportConfig || !reportConfig.headers?.length) {
      message.warning("No report configuration available");
      return;
    }

    if (!filteredData.length) {
      message.warning("No report data available to export");
      return;
    }

    try {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      // Report title
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text(reportConfig.reportName || "Report", pageWidth / 2, 15, {
        align: "center",
      });

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(
        `Generated: ${dayjs().format("DD-MM-YYYY HH:mm")}`,
        pageWidth - 14,
        22,
        {
          align: "right",
        },
      );

      // ===============================
      // APPLIED FILTERS
      // ===============================
      const appliedFilters = [];

      reportConfig.filters?.forEach((filter) => {
        const value = filterValues[filter.key];

        if (value !== undefined && value !== null && value !== "") {
          let displayValue = value;

          // Format date
          if (filter.type === "date" && dayjs.isDayjs(value)) {
            displayValue = value.format("DD-MM-YYYY");
          }

          // For Select values, display the label if required
          if (typeof displayValue === "object" && displayValue !== null) {
            displayValue = displayValue.label || displayValue.value || "";
          }

          appliedFilters.push(`${filter.label}: ${displayValue}`);
        }
      });

      // ===============================
      // FILTER TEXT
      // ===============================
      if (appliedFilters.length > 0) {
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        const filterText = `Filters: ${appliedFilters.join(" | ")}`;

        doc.text(filterText, pageWidth / 2, 28, {
          align: "center",
          maxWidth: pageWidth - 28,
        });
      }
      // Dynamic headers
      const tableHeaders = reportConfig.headers.map((header) => header.label);

      // Dynamic rows
      const tableRows = filteredData.map((record) =>
        reportConfig.headers.map((header) =>
          formatValue(record[header.key], header.key),
        ),
      );

      autoTable(doc, {
        startY: appliedFilters.length ? 34 : 27,

        head: [tableHeaders],
        body: tableRows,

        // Table layout
        theme: "grid",

        styles: {
          fontSize: 7,
          cellPadding: 3,
          overflow: "linebreak",
          valign: "middle",
          lineWidth: 0.2,
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineWidth: 0.3,
        },

        bodyStyles: {
          fontSize: 7,
          valign: "middle",
        },

        alternateRowStyles: {
          fillColor: [248, 248, 248],
        },

        columnStyles: {
          // Example:
          // 0: { cellWidth: 25 },
          // 1: { cellWidth: 30 },
          // 2: { cellWidth: 40 },
        },

        margin: {
          top: 10,
          right: 10,
          bottom: 15,
          left: 10,
        },

        // Footer on every PDF page
        didDrawPage: () => {
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text(
            "Generated by Pereco | Powered by perennialcode",
            doc.internal.pageSize.getWidth() / 2,
            doc.internal.pageSize.getHeight() - 8,
            {
              align: "center",
            },
          );
        },
      });

      // Footer

      const pageCount = doc.internal.getNumberOfPages();

      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);

        doc.setFontSize(8);

        doc.text(
          `Page ${i} of ${pageCount}`,
          doc.internal.pageSize.getWidth() - 30,
          doc.internal.pageSize.getHeight() - 8,
        );
      }

      // File name
      const fileName = `${(reportConfig.reportName || "Report")
        .replace(/[^a-z0-9]/gi, "_")
        .toLowerCase()}_${dayjs().format("DD-MM-YYYY")}.pdf`;

      doc.save(fileName);

      message.success("PDF exported successfully");
    } catch (error) {
      console.error("PDF Export Error:", error);
      message.error("Failed to export PDF");
    }
  };

  // ===============================
  // EXPORT REPORT TO EXCEL
  // ===============================
  const handleExportExcel = () => {
    if (!reportConfig || !reportConfig.headers?.length) {
      message.warning("No report configuration available");
      return;
    }

    if (!filteredData.length) {
      message.warning("No report data available to export");
      return;
    }

    try {
      // Convert dynamic report data into Excel rows
      const excelData = filteredData.map((record) => {
        const row = {};

        reportConfig.headers.forEach((header) => {
          row[header.label] = formatValue(record[header.key], header.key);
        });

        return row;
      });

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Calculate column widths
      const columnWidths = reportConfig.headers.map((header) => {
        const headerLength = header.label?.length || 10;

        const maxDataLength = Math.max(
          ...filteredData.map((record) => {
            const value = formatValue(record[header.key], header.key);

            return String(value ?? "").length;
          }),
          0,
        );

        return {
          wch: Math.min(Math.max(headerLength, maxDataLength, 10), 40),
        };
      });

      worksheet["!cols"] = columnWidths;

      // Create workbook
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      // File name
      const fileName = `${(reportConfig.reportName || "Report")
        .replace(/[^a-z0-9]/gi, "_")
        .toLowerCase()}_${dayjs().format("DD-MM-YYYY")}.xlsx`;

      // Download
      XLSX.writeFile(workbook, fileName);

      message.success("Excel exported successfully");
    } catch (error) {
      console.error("Excel Export Error:", error);
      message.error("Failed to export Excel");
    }
  };

  return (
    <>
      <Base>
        <div className="page-wrapper pt-3">
          <div className="content">
            {/* <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard">
                          <i className="fas fa-home fa-lg" />
                        </Link>
                      </li>
                      <h4 className="breadcrumb-item " aria-current="page">
                        {reportConfig.reportName}
                      </h4>
                    </ol>
                  </nav>
                
                </div>
                <div>

                <ul className="table-top-head">
                  <li className="">
                    <a
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="PDF"
                      onClick={handleExportPDF}
                      className="btn btn-light btn-sm px-0"
                    >
                     
                      <i
                        className="fa-solid fa-file-pdf fa-2xl"
                        style={{ color: "#ff0000" }}
                      ></i>
                    </a>
                  </li>
                  <li className="">
                    <a
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Excel"
                      onClick={handleExportExcel}
                      className="btn btn-light btn-sm "
                    >
                   
                      <i
                        className="fa-solid fa-file-excel fa-2xl"
                        style={{ color: "#217346" }}
                      ></i>
                    </a>
                  </li>
                </ul>
                </div>
              </div>
            </div> */}
            <div className="row align-items-center">
              {/* Left - Report Name */}
              <div className="col-10">
                <div className="page-title">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard">
                          <i className="fas fa-home fa-lg" />
                        </Link>
                      </li>

                      <li
                        className="breadcrumb-item active text-nowrap"
                        aria-current="page"
                      >
                        <h4 className="mb-0 text-nowrap">
                          {reportConfig.reportName}
                        </h4>
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>

              {/* Right - PDF & Excel */}
              <div className="col-2 d-flex justify-content-end">
                <ul
                  className="table-top-head d-flex align-items-center mb-0 p-0"
                  style={{ gap: "6px" }}
                >
                  <li className="flex-shrink-0 m-0">
                    <button
                      type="button"
                      title="PDF"
                      onClick={handleExportPDF}
                      className="btn btn-light btn-sm d-flex align-items-center justify-content-center p-1"
                    >
                      <i
                        className="fa-solid fa-file-pdf fa-lg"
                        style={{ color: "#ff0000" }}
                      />
                    </button>
                  </li>

                  <li className="flex-shrink-0 m-0">
                    <button
                      type="button"
                      title="Excel"
                      onClick={handleExportExcel}
                      className="btn btn-light btn-sm d-flex align-items-center justify-content-center p-1"
                    >
                      <i
                        className="fa-solid fa-file-excel fa-lg"
                        style={{ color: "#217346" }}
                      />
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="page-header p-0">
              <div className="d-flex align-items-center justify-content-between w-100 ">
                {/* Left - Page Title */}

                {/* Right - PDF & Excel */}
              </div>
            </div>
            {showFilters && (
              <div className="row">
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                      <div className="row g-3 align-items-end ">
                        {reportConfig.filters?.map((filter) => {
                          // DATE
                          // if (filter.type === "date") {
                          //   return (
                          //     <div className="col-auto" key={filter.key}>
                          //       <label className="form-label d-block mb-1">
                          //         {filter.label}

                          //         {filter.required && (
                          //           <span className="text-danger ms-1">*</span>
                          //         )}
                          //       </label>

                          //       <DatePicker
                          //         style={{ width: "160px", minWidth: 0 }}
                          //         format="DD-MM-YYYY"
                          //         value={filterValues[filter.key] || null}
                          //         onChange={(date) =>
                          //           handleFilterChange(filter.key, date)
                          //         }
                          //       />
                          //     </div>
                          //   );
                          // }
                          // NOTES / REMINDERS DATE RANGE

                          if (
                            !isNotesOrReminders &&
                            (filter.key === "fromDate" ||
                              filter.key === "toDate" ||
                              filter.type === "date")
                          ) {
                            return (
                              <div className="col-auto" key={filter.key}>
                                <label className="form-label d-block mb-1">
                                  {filter.label}

                                  {filter.required && (
                                    <span className="text-danger ms-1">*</span>
                                  )}
                                </label>

                                <DatePicker
                                  style={{ width: "160px", minWidth: 0 }}
                                  format="DD-MM-YYYY"
                                  value={filterValues[filter.key] || null}
                                  onChange={(date) =>
                                    handleFilterChange(filter.key, date)
                                  }
                                  allowClear
                                />
                              </div>
                            );
                          }

                          // CUSTOMER
                          if (
                            filter.key === "customerId" ||
                            filter.key === "CustomerId" ||
                            filter.key === "customerid"
                          ) {
                            return (
                              <div className="col-auto" key={filter.key}>
                                <label className="form-label d-block mb-1">
                                  {filter.label}

                                  {filter.required && (
                                    <span className="text-danger ms-1">*</span>
                                  )}
                                </label>

                                <Select
                                  style={{ width: "180px" }}
                                  placeholder={`Select ${filter.label}`}
                                  value={filterValues[filter.key] ?? undefined}
                                  onChange={(value) =>
                                    handleFilterChange(filter.key, value)
                                  }
                                  options={customers}
                                  allowClear
                                  showSearch
                                  optionFilterProp="label"
                                />
                              </div>
                            );
                          }

                          // LEAD
                          if (filter.key === "leadId") {
                            return (
                              <div className="col-auto" key={filter.key}>
                                <label className="form-label d-block mb-1">
                                  {filter.label}

                                  {filter.required && (
                                    <span className="text-danger ms-1">*</span>
                                  )}
                                </label>

                                <Select
                                  style={{ width: "180px" }}
                                  placeholder={`Select ${filter.label}`}
                                  value={filterValues[filter.key] ?? undefined}
                                  onChange={(value) =>
                                    handleFilterChange(filter.key, value)
                                  }
                                  options={leads}
                                  allowClear
                                  showSearch
                                  optionFilterProp="label"
                                />
                              </div>
                            );
                          }
                          if (filter.key === "rel_type") {
                            return (
                              <div className="col-auto" key={filter.key}>
                                <label className="form-label d-block mb-1">
                                  {filter.label}

                                  {filter.required && (
                                    <span className="text-danger ms-1"></span>
                                  )}
                                </label>

                                <Select
                                  style={{ width: "160px" }}
                                  placeholder={`Select ${filter.label}`}
                                  value={filterValues[filter.key] ?? undefined}
                                  onChange={(value) => {
                                    handleFilterChange("rel_type", value);

                                    // Clear selected Related Record
                                    handleFilterChange("rel_id", undefined);

                                    // Load records based on selected type
                                    if (value) {
                                      getRelatedRecords(value);
                                    }
                                  }}
                                  options={RELATED_TO_OPTIONS}
                                  allowClear
                                  showSearch
                                  optionFilterProp="label"
                                />
                              </div>
                            );
                          }
                          if (filter.key === "rel_id") {
                            return (
                              <div className="col-auto" key={filter.key}>
                                <label className="form-label d-block mb-1">
                                  {filter.label}

                                  {filter.required && (
                                    <span className="text-danger ms-1">*</span>
                                  )}
                                </label>

                                <Select
                                  style={{ width: "160px" }}
                                  placeholder={`Select ${filter.label}`}
                                  value={filterValues[filter.key] ?? undefined}
                                  onChange={(value) =>
                                    handleFilterChange("rel_id", value)
                                  }
                                  options={relatedOptions}
                                  allowClear
                                  showSearch
                                  optionFilterProp="label"
                                  disabled={!filterValues.rel_type}
                                />
                              </div>
                            );
                          }

                          if (
                            isNotesOrReminders &&
                            (filter.key === "fromDate" ||
                              filter.key === "toDate" ||
                              filter.type === "date")
                          ) {
                            // Don't render the API's individual date fields
                            // We will show one common dropdown instead.
                            if (filter.key === "toDate") {
                              return null;
                            }

                            if (filter.key === "fromDate") {
                              return (
                                <div className="col-auto" key="dateRange">
                                  <label className="form-label d-block mb-1">
                                    Date
                                  </label>

                                  <Select
                                    style={{ width: "160px" }}
                                    placeholder="Select Date"
                                    value={filterValues.dateRange || undefined}
                                    onChange={(value) =>
                                      handleFilterChange("dateRange", value)
                                    }
                                    options={[
                                      {
                                        value: "today",
                                        label: "Today",
                                      },
                                      {
                                        value: "week",
                                        label: "This Week",
                                      },
                                      {
                                        value: "month",
                                        label: "This Month",
                                      },
                                    ]}
                                    allowClear
                                  />
                                </div>
                              );
                            }
                          }

                          if (filter.key === "staffid") {
                            if (isNotesOrReminders) {
                              return null;
                            }

                            return (
                              <div className="col-auto" key={filter.key}>
                                <label className="form-label d-block mb-1">
                                  {filter.label}

                                  {filter.required && (
                                    <span className="text-danger ms-1">*</span>
                                  )}
                                </label>

                                <Select
                                  style={{ width: "160px" }}
                                  placeholder={`Select ${filter.label}`}
                                  value={filterValues[filter.key] ?? undefined}
                                  onChange={(value) =>
                                    handleFilterChange(filter.key, value)
                                  }
                                  options={staff}
                                  allowClear
                                  showSearch
                                  optionFilterProp="label"
                                />
                              </div>
                            );
                          }

                          if (filter.type === "select") {
                            return (
                              <div className="col-auto" key={filter.key}>
                                <label className="form-label d-block mb-1">
                                  {filter.label}
                                  {filter.required && (
                                    <span className="text-danger ms-1">*</span>
                                  )}
                                </label>

                                <Select
                                  style={{ width: "160px" }}
                                  placeholder={`Select ${filter.label}`}
                                  value={filterValues[filter.key] ?? undefined}
                                  onChange={(value) =>
                                    handleFilterChange(filter.key, value)
                                  }
                                  allowClear
                                  showSearch
                                  optionFilterProp="label"
                                />
                              </div>
                            );
                          }

                          // TEXT INPUT
                          return (
                            <div className="col-auto" key={filter.key}>
                              <label className="form-label d-block mb-1">
                                {filter.label}

                                {filter.required && (
                                  <span className="text-danger ms-1">*</span>
                                )}
                              </label>

                              <Input
                                style={{ width: "180px" }}
                                placeholder={`Enter ${filter.label}`}
                                value={filterValues[filter.key] || ""}
                                onChange={(e) =>
                                  handleFilterChange(filter.key, e.target.value)
                                }
                              />
                            </div>
                          );
                        })}

                        {/* APPLY / RESET */}
                        <div className="col-auto d-flex gap-2">
                          <Button
                            type="primary"
                            title="Apply"
                            onClick={handleApply}
                            loading={loading}
                            icon={<CheckOutlined />}
                          />

                          <Button
                            title="refersh"
                            onClick={() => {
                              handleReset();
                            }}
                            icon={<ReloadOutlined />}
                            disabled={loading}
                          />

                          <Button
                            title="close"
                            onClick={() => setShowFilters(!showFilters)}
                            icon={<CloseOutlined />}
                          ></Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div className="card table-list-card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  {/* Search */}
                  <div className="search-set">
                    <Input
                      allowClear
                      placeholder="Search report..."
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      style={{ width: 280 }}
                    />
                  </div>

                  {/* Filter Button */}
                  <div className="d-flex align-items-end justify-content-between">
                    <Button
                      title="Open Filter"
                      type="primary"
                      icon={<FilterOutlined />}
                      onClick={() => setShowFilters(true)}
                    />
                  </div>
                </div>

                <div className="card-body p-0">
                  <div className="table-responsive p-0">
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "250px",
                        }}
                      >
                        <Spin size="large" />
                      </div>
                    ) : (
                      <Table
                        columns={columns}
                        dataSource={filteredData}
                        rowKey={(record, index) =>
                          record.id || record.ID || record.report_id || index
                        }
                        scroll={{ x: "max-content" }}
                        // pagination={{
                        //   pageSize: 10,
                        //   showSizeChanger: true,
                        //   pageSizeOptions: ["10", "20", "50", "100"],
                        //   showTotal: (total, range) =>
                        //     `${range[0]}-${range[1]} of ${total} items`,
                        // }}
                        pagination={{
                          pageSize: 10,
                          showSizeChanger: false,
                          showTotal: false,
                          showLessItems: true,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div> */}

        <Footer></Footer>
      </Base>
    </>
  );
};

export default Reports;
